import { HttpError } from "@bps/http-client";

export class DuplicateError extends HttpError {}
